import React from 'react';
import './SuccessPayment.css';

const SuccessPayment = () => {

    return (
        <div className="success-payment">
            <div className="success-payment-container">
                <h1>Payment Successful!</h1>
                <p>Thank you for your payment. Your transaction was successful.</p>
               
            </div>
        </div>
    );
};

export default SuccessPayment;
